import { createFileRoute } from '@tanstack/react-router';

/**
 * Página inicial do Portal Vega (Bloco 1 — DEC-060). Componente vem de index.lazy.tsx
 * (code-splitting por rota, D4/DEC-060).
 */
export const Route = createFileRoute('/')({});
